export class LessonProgress {
  completed: boolean = false;

  toPlain(): object {
    return {
      completed: this.completed,
    };
  }
}
